import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/warehouseSlice";
import warehouseApis from "src/api/warehouse";
import { common } from "src/types";
import { constants } from "src/constants/common";

// ✅ Create Warehouse Saga
function* CreateWarehouseSaga({
  payload,
}: ReturnType<typeof actions.createWarehouseRequest> & { payload: any }) {
  try {
    const response: common.ResponseGenerator = yield call(
      warehouseApis.createWarehouse,
      payload
    );
    yield put(actions.createWarehouseSuccess(response));
  } catch (error) {
    yield put(
      actions.createWarehouseError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

// ✅ Get Warehouse List Saga
function* GetWarehouseListSaga({
  payload,
}: ReturnType<typeof actions.getWarehouseListRequest> & {
  payload: {
    page?: number;
    limit: number;
    search?: string;
    status?: "active" | "inactive";
  };
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      warehouseApis.getWarehouseList,
      payload
    );
    yield put(actions.getWarehouseListSuccess(response));
  } catch (error) {
    yield put(
      actions.getWarehouseListError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

// ✅ Edit Warehouse Saga
function* EditWarehouseSaga({
  payload,
}: ReturnType<typeof actions.editWarehouseRequest> & { payload: any }) {
  try {
    const response: common.ResponseGenerator = yield call(
      warehouseApis.editWarehouse,
      payload
    );
    yield put(actions.editWarehouseSuccess(response));
  } catch (error) {
    yield put(
      actions.editWarehouseError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

// ✅ Delete Warehouse Saga
function* DeleteWarehouseSaga({
  payload,
}: ReturnType<typeof actions.deleteWarehouseRequest> & { payload: string }) {
  try {
    const response: common.ResponseGenerator = yield call(
      warehouseApis.deleteWarehouse,
      payload
    );
    yield put(actions.deleteWarehouseSuccess(response));
  } catch (error) {
    yield put(
      actions.deleteWarehouseError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

export default function* warehouseSaga() {
  yield all([
    takeEvery(actions.createWarehouseRequest, CreateWarehouseSaga),
    takeEvery(actions.getWarehouseListRequest, GetWarehouseListSaga),
    takeEvery(actions.editWarehouseRequest, EditWarehouseSaga),
    takeEvery(actions.deleteWarehouseRequest, DeleteWarehouseSaga),
  ]);
}
